import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { DeviceInfo } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';


@Component({
    components: {
    },
})
export default class DeviceViewMixin extends Vue {

    @Mutation('user/setLastVisitedUrl')
    public setLastVisitedUrl: (url: string) => any;

    @Prop()
    public deviceNumber: string;

    public get deviceInfo(): DeviceInfo | null {
        return this.deviceNumber
            && this.getDeviceInfo
            && this.getDeviceInfo(this.deviceNumber) || null;
    }

    public get progress(): number {
        return Math.round(this.getDeviceProgress(this.deviceNumber));
    }

    public get isDeviceOnline(): boolean {
        if (!this.deviceInfo) {
            return false;
        }

        if (this.deviceInfo
            && this.deviceInfo.connections
            && this.deviceInfo.connections.find((c) => c.online)) {
                return true;
            }
        return false;
    }

    @Getter('devices/deviceInfo')
    private getDeviceInfo?: (deviceNumber: string) => DeviceInfo | null;

    @Getter('devices/getDeviceProgress')
    private getDeviceProgress: (deviceNumber: string) => number;

    public created() {
        this.$store.dispatch('devices/load');
        if (this.deviceNumber) {
            ApiProvider.getEventApi().subscribe(this.deviceNumber);
        }
    }
    public mounted() {
        this.setLastVisitedUrl(this.$route.fullPath);
    }
    public beforeDestroy() {
        this.setLastVisitedUrl('');
    }
}
